import * as React from 'react';
import { Line } from 'react-chartjs-2';
import Chartify from  '@shipsy/chartify';

class LineViz extends React.PureComponent<any, any> {

  render() {
    const { formData, chartData } = this.props;
    const chartifyInstance = new Chartify.LineData(chartData, formData);
    const chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();
    return <Line data={chartifyData.data.lineChartData} options={chartifyData.options} />;
  }
}

export default LineViz;
